export const splitTextIntoLines = (text: string, maxWidth: number): string[] => {
  const FONT_SIZE = 17;
  const CHAR_WIDTH_RATIO = 0.5;
  const avgCharWidth = FONT_SIZE * CHAR_WIDTH_RATIO;
  let maxChars = Math.floor(maxWidth / avgCharWidth);

  if (maxChars < 1) maxChars = 1; // Prevent invalid array length and infinite loop

  const words = text.split(' ');
  const lines: string[] = [];
  let line = '';

  for (const word of words) {
    if ((line.length ? line.length + 1 : 0) + word.length <= maxChars) {
      line = line ? `${line} ${word}` : word;
    } else {
      if (line) {
        lines.push(line);
      }
      if (word.length > maxChars) {
        let start = 0;
        while (start < word.length) {
          lines.push(word.slice(start, start + maxChars));
          start += maxChars;
        }
        line = '';
      } else {
        line = word;
      }
    }
  }

  if (line) {
    lines.push(line);
  }

  return lines;
};
